/**
 * Provides theme-aware invite modal styles so the modal respects dark mode.
 */

import React, { createContext, useContext, useMemo } from 'react';
import { useTheme } from '../../theme/useTheme';
import { getInviteModalStyles, inviteModalStyles } from '../styles/inviteModal.styles';
import type { InviteModalStyles } from '../styles/inviteModal.styles';

const InviteModalStylesContext = createContext<InviteModalStyles | null>(null);

export function InviteModalStylesProvider({ children }: { children: React.ReactNode }) {
  const theme = useTheme();
  const styles = useMemo(() => getInviteModalStyles(theme), [theme]);
  return (
    <InviteModalStylesContext.Provider value={styles}>
      {children}
    </InviteModalStylesContext.Provider>
  );
}

export function useInviteModalStyles(): InviteModalStyles {
  const styles = useContext(InviteModalStylesContext);
  if (!styles) {
    return inviteModalStyles;
  }
  return styles;
}
